import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import navbar from './components/navbar/index.js'
import 'amfe-flexible'
import '@/assets/common/index.scss'
import common from '@/components/common'
import { fetch, post, patch, put, del, get, compressImg, GetQueryString } from './utils/request_lock'
import { Popup, DatetimePicker, Dialog, Toast, Search, Button, List, Cell, SwipeCell, Card, NavBar, Form, Field, Picker, Icon, Image, Uploader } from 'vant'
import { Select, Option } from 'element-ui'

/* import Vconsole from 'vconsole'
const vConsole = new Vconsole()
Vue.use(vConsole)
 */
Vue.prototype.get = fetch
Vue.prototype.post = post
Vue.prototype.get = get
Vue.prototype.del = del
Vue.prototype.patch = patch
Vue.prototype.put = put
Vue.prototype.compressImg = compressImg
Vue.prototype.GetQueryString = GetQueryString
// Vue.prototype.getPic = getPic

Vue.config.productionTip = false
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Search)
Vue.use(List)
Vue.use(Cell)
Vue.use(Card)
Vue.use(SwipeCell)
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Select)
Vue.use(Button)
Vue.use(Option)
Vue.use(Image)
Vue.use(Uploader)
Vue.use(navbar)
Vue.prototype.$common = common // 挂载到 Vue 实例上

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
